export const CATEGORIES_PER_PAGE = 30;
